/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* === Majestic Filatures — mobile product image zoom === */
/* === Majestic Filatures — product image zoom === */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-product')) return;

  var MAX_SCALE = 4, TAP_SCALE = 2.5;
  var overlay, track, counter, magBtn, slides = [], current = 0;
  var scale = 1, tx = 0, ty = 0;
  var startX = 0, startY = 0, startTx = 0, startTy = 0, startDist = 0, startScale = 1;
  var mode = null, lastTap = 0, dragging = false;

  var SVG_IN  = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><line x1="15.5" y1="15.5" x2="21" y2="21"/><line x1="7.5" y1="10.5" x2="13.5" y2="10.5"/><line x1="10.5" y1="7.5" x2="10.5" y2="13.5"/></svg>';
  var SVG_OUT = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><line x1="15.5" y1="15.5" x2="21" y2="21"/><line x1="7.5" y1="10.5" x2="13.5" y2="10.5"/></svg>';
  var SVG_PLAIN = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><line x1="15.5" y1="15.5" x2="21" y2="21"/></svg>';

  function galleryImages() {
    var g = document.querySelector('.Product__Gallery') ||
            document.querySelector('.Product__Slideshow');
    if (!g) return [];
    return Array.prototype.slice.call(g.querySelectorAll('img'));
  }

  function hiRes(url) {
    if (!url) return '';
    url = url.split('?')[0];
    url = url.replace(/%7Bwidth%7D/gi, '1946').replace(/\{width\}/g, '1946');
    url = url.replace(/_(\d+)x(\d+)?(@\dx)?\.(jpg|jpeg|png|webp)/i, '_1946x.$4');
    return url;
  }

  /* ---- magnifier trigger on the product gallery ---- */
  function injectTrigger() {
    if (document.querySelector('.mfZoomTrigger')) return;
    var g = document.querySelector('.Product__Gallery') ||
            document.querySelector('.Product__Slideshow');
    if (!g) return;
    g.classList.add('mfZoomHost');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mfZoomTrigger';
    b.setAttribute('aria-label', 'Zoom image');
    b.innerHTML = SVG_PLAIN;
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      open(current || 0);
    });
    g.appendChild(b);
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'mfZoom';
    overlay.innerHTML =
      '<button class="mfZoom__mag" type="button" aria-label="Zoom in"></button>' +
      '<div class="mfZoom__track"></div>' +
      '<div class="mfZoom__count"></div>' +
      '<div class="mfZoom__bar">' +
        '<button class="mfZoom__btn" type="button" data-go="-1" aria-label="Previous">&#8249;</button>' +
        '<button class="mfZoom__btn" type="button" data-close="1" aria-label="Close">&#10005;</button>' +
        '<button class="mfZoom__btn" type="button" data-go="1" aria-label="Next">&#8250;</button>' +
      '</div>';
    document.body.appendChild(overlay);
    track   = overlay.querySelector('.mfZoom__track');
    counter = overlay.querySelector('.mfZoom__count');
    magBtn  = overlay.querySelector('.mfZoom__mag');
    magBtn.innerHTML = SVG_IN;

    overlay.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.dataset.close) { close(); return; }
      if (b.dataset.go)    { go(parseInt(b.dataset.go, 10)); return; }
      if (b === magBtn || magBtn.contains(e.target)) { toggleZoom(); }
    });

    overlay.addEventListener('touchstart', onStart, { passive: false });
    overlay.addEventListener('touchmove',  onMove,  { passive: false });
    overlay.addEventListener('touchend',   onEnd);
    document.addEventListener('keydown', onKey);
  }

  function open(index) {
    var imgs = galleryImages();
    if (!imgs.length) return;
    if (!overlay) build();
    track.innerHTML = '';
    slides = imgs.map(function (img) {
      var s = document.createElement('div');
      s.className = 'mfZoom__slide';
      var i = document.createElement('img');
      i.src = hiRes(img.getAttribute('data-src') || img.currentSrc || img.src);
      i.alt = img.alt || '';
      s.appendChild(i);
      track.appendChild(s);
      return i;
    });
    current = Math.min(index || 0, slides.length - 1);
    scale = 1; tx = 0; ty = 0;
    layout(false);
    document.documentElement.classList.add('mfZoom-open');
    overlay.classList.add('is-open');
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.style.opacity = '';
    document.documentElement.classList.remove('mfZoom-open');
    scale = 1; tx = 0; ty = 0;
  }

  function go(dir) {
    var n = current + dir;
    if (n < 0 || n >= slides.length) return;
    current = n; scale = 1; tx = 0; ty = 0;
    layout(true);
  }

  function toggleZoom() {
    scale = scale > 1 ? 1 : TAP_SCALE;
    tx = 0; ty = 0;
    applyImg(true);
  }

  function updateMag() {
    if (magBtn) {
      magBtn.innerHTML = scale > 1 ? SVG_OUT : SVG_IN;
      magBtn.setAttribute('aria-label', scale > 1 ? 'Zoom out' : 'Zoom in');
    }
  }

  function layout(animate) {
    track.style.transition = animate ? 'transform .3s cubic-bezier(.4,0,.2,1)' : 'none';
    track.style.transform  = 'translate3d(' + (-current * 100) + '%,0,0)';
    counter.textContent = (current + 1) + ' / ' + slides.length;
    applyImg(animate);
  }

  function applyImg(animate) {
    var img = slides[current];
    if (!img) return;
    img.style.transition = animate ? 'transform .25s cubic-bezier(.4,0,.2,1)' : 'none';
    img.style.transform  = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + scale + ')';
    updateMag();
  }

  function clamp() {
    var img = slides[current];
    if (!img) return;
    var maxX = Math.max(0, (img.offsetWidth  * scale - window.innerWidth)  / 2);
    var maxY = Math.max(0, (img.offsetHeight * scale - window.innerHeight) / 2);
    tx = Math.min(maxX, Math.max(-maxX, tx));
    ty = Math.min(maxY, Math.max(-maxY, ty));
  }

  function dist(t) {
    var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function doubleTap(touch) {
    if (scale > 1) { scale = 1; tx = 0; ty = 0; }
    else {
      var img = slides[current], r = img.getBoundingClientRect();
      scale = TAP_SCALE;
      tx = -(touch.clientX - (r.left + r.width  / 2)) * (TAP_SCALE - 1);
      ty = -(touch.clientY - (r.top  + r.height / 2)) * (TAP_SCALE - 1);
      clamp();
    }
    applyImg(true);
  }

  function onStart(e) {
    if (e.target.closest('button')) return;
    if (e.touches.length === 2) {
      mode = 'pinch'; startDist = dist(e.touches); startScale = scale;
      e.preventDefault();
    } else if (e.touches.length === 1) {
      var now = Date.now();
      if (now - lastTap < 300) { doubleTap(e.touches[0]); lastTap = 0; e.preventDefault(); return; }
      lastTap = now;
      mode = scale > 1 ? 'pan' : 'swipe';
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      startTx = tx; startTy = ty; dragging = true;
    }
  }

  function onMove(e) {
    if (mode === 'pinch' && e.touches.length === 2) {
      e.preventDefault();
      scale = Math.min(MAX_SCALE, Math.max(1, startScale * (dist(e.touches) / startDist)));
      if (scale === 1) { tx = 0; ty = 0; }
      applyImg(false);
      return;
    }
    if (!dragging || e.touches.length !== 1) return;
    var dx = e.touches[0].clientX - startX, dy = e.touches[0].clientY - startY;
    if (mode === 'pan') {
      e.preventDefault();
      tx = startTx + dx; ty = startTy + dy; clamp(); applyImg(false);
    } else if (Math.abs(dx) > Math.abs(dy)) {
      e.preventDefault();
      track.style.transition = 'none';
      track.style.transform = 'translate3d(calc(' + (-current * 100) + '% + ' + dx + 'px),0,0)';
    } else if (dy > 0) {
      e.preventDefault();
      overlay.style.opacity = Math.max(0.3, 1 - dy / 400);
      track.style.transition = 'none';
      track.style.transform = 'translate3d(' + (-current * 100) + '%,' + dy + 'px,0)';
    }
  }

  function onEnd(e) {
    if (mode === 'pinch') {
      mode = null; dragging = false;
      if (scale <= 1) { scale = 1; tx = 0; ty = 0; applyImg(true); }
      return;
    }
    if (!dragging) { mode = null; return; }
    dragging = false;
    var t = e.changedTouches[0];
    var dx = t.clientX - startX, dy = t.clientY - startY;
    if (mode === 'swipe') {
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 60) {
        current = Math.min(slides.length - 1, Math.max(0, current + (dx < 0 ? 1 : -1)));
        scale = 1; tx = 0; ty = 0;
      } else if (dy > 100) { close(); return; }
      overlay.style.opacity = '';
      layout(true);
    }
    mode = null;
  }

  function onKey(e) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape')     close();
    if (e.key === 'ArrowRight') go(1);
    if (e.key === 'ArrowLeft')  go(-1);
  }

  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.Product__Gallery img, .Product__Slideshow img');
    if (!img) return;
    var idx = galleryImages().indexOf(img);
    if (idx < 0) return;
    e.preventDefault(); e.stopPropagation();
    open(idx);
  }, true);

  if (document.readyState !== 'loading') injectTrigger();
  else document.addEventListener('DOMContentLoaded', injectTrigger);
  document.addEventListener('variant:changed', injectTrigger);
})();
